(function () {
  const header = document.getElementById('MerooHeader');
  const drawer = document.getElementById('MerooNavDrawer');
  if (!header) return;

  const threshold = Number(header.dataset.scrollThreshold || 30);

  const onScroll = () => {
    header.classList.toggle('is-stuck', window.scrollY > threshold);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const dropdowns = [...header.querySelectorAll('.meroo-header__dropdown')];
  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      dropdowns.forEach((other) => {
        if (other !== dropdown) other.open = false;
      });
    });
  });
  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target) || event.target.closest('.meroo-header__dropdown-link')) {
        dropdown.open = false;
      }
    });
  });
  header.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDropdown = dropdowns.find((dropdown) => dropdown.open);
    if (!openDropdown) return;
    openDropdown.open = false;
    openDropdown.querySelector('summary').focus();
    event.preventDefault();
  });

  // Drop Shopify account popover a little below the icon (not flush to the header).
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom + 14));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!drawer || typeof drawer.showModal !== 'function') return;

  const openButtons = document.querySelectorAll('[data-meroo-drawer-open]');
  const closeButtons = document.querySelectorAll('[data-meroo-drawer-close]');

  const setExpanded = (open) => {
    openButtons.forEach((btn) => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
  };

  const openDrawer = () => {
    if (drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    setExpanded(true);
    document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    if (!drawer.open) return;
    drawer.classList.add('is-closing');
    setExpanded(false);
    window.setTimeout(() => {
      drawer.close();
      drawer.classList.remove('is-closing');
      document.documentElement.style.overflow = '';
    }, 300);
  };

  openButtons.forEach((btn) => btn.addEventListener('click', openDrawer));
  closeButtons.forEach((btn) => btn.addEventListener('click', closeDrawer));

  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });

  drawer.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDrawer();
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => closeDrawer());
  });
})();
